import React from "react";
import FinanceTop from "../../components/financeSession/top/FinanceTop";
import Hearth from "../../components/financeSession/hearth/Hearth";
import DataFin from "../../components/financeSession/data/DataFin";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
export default function Finanching() {
  return (
    <div>
      <FinanceTop />
      <Breadcrumb />
      <Hearth />
      <DataFin />
    </div>
  );
}
